import { environment } from 'environments/environment';

let _log: (message?: any, ...optionalParams: any[]) => void;
_log = console.log.bind(window.console);
if (environment.production) {
    _log = (message?: any, ...optionalParams: any[]): void => {};
} 
export const log = _log;
